export enum EstadosUsuario {
    activo = 22,
    inactivo = 23,
    bloqueado = 24,
    noRegistrado = 25,
    pendienteActivacion = 26
}